import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServies";
import Swal from "sweetalert2";

const RequisitionReport = () => {

  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("all");
  const [totalcount, setTotalCount] = useState(0);


  // ==========================================
  // FETCH REPORT
  // ==========================================
  const fetchReport = async () => {

    if (!fromDate || !toDate) {

      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });

      return;
    }


    const start =
      new Date(fromDate);

    const end =
      new Date(toDate);

    start.setHours(
      0,
      0,
      0,
      0
    );

    end.setHours(
      0,
      0,
      0,
      0
    );


    const diffTime =
      end - start;

    const diffDays =
      diffTime /
      (1000 * 60 * 60 * 24);


    if (diffDays < 0) {

      Swal.fire({
        icon: "warning",
        title: "Invalid Range",
        text: "To Date cannot be before From Date.",
      });

      return;
    }


    if (diffDays > 30) {

      Swal.fire({
        icon: "warning",
        title: "Invalid Range",
        text: "You can generate report for maximum 31 days only.",
      });

      return;
    }


    setLoading(true);


    try {

      const response =
        await RequestServies.report({

          fromDate,

          toDate,

          status,

        });


      setReportData(
        response.data
      );

      setTotalCount(
        response.count
      );


      Swal.fire({
        icon: "success",
        title: "Report Generated",
        text: "Report Successfully Generated for the Selected Date Range.",
      });


    } catch (error) {

      console.error(
        "Error fetching report data:",
        error
      );


      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch report data. Please try again later.",
      });


    } finally {

      setLoading(false);

    }

  };


  // ==========================================
  // FILTER DATA
  // ==========================================
  const filteredData =
    reportData.filter(
      (item) => {

        const queries =
          searchQuery
            .toLowerCase()
            .split(" ")
            .filter(
              (q) =>
                q.trim() !== ""
            );


        return queries.every(
          (query) =>

            String(
              item?.inventory
                ?.store
                ?.name || ""
            )
              .toLowerCase()
              .includes(query) ||

            String(
              item?.requisitionNo
                ?.requisitionNo || ""
            )
              .toLowerCase()
              .includes(query) ||

            String(
              item?.inventory
                ?.masterItem
                ?.partNo || ""
            )
              .toLowerCase()
              .includes(query) ||

            String(
              item?.inventory
                ?.masterItem
                ?.description || ""
            )
              .toLowerCase()
              .includes(query) ||

            String(
              item?.po
                ?.poNumber ||
              "local"
            )
              .toLowerCase()
              .includes(query)

        );

      }
    );


  // ==========================================
  // TOTAL RECEIVED QTY
  // ==========================================
  const totalReceivedQty =
    filteredData.reduce(
      (sum, item) => {

        return (
          sum +
          (
            Number(
              item?.qtyRecived
            ) || 0
          )
        );

      },
      0
    );


  // ==========================================
  // DOWNLOAD EXISTING REQUISITION REPORT
  // ==========================================
  const downloadExcel = async () => {

    if (
      !fromDate ||
      !toDate
    ) {

      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });

      return;

    }


    try {

      Swal.fire({
        title: "Preparing Report...",
        text: "Downloading full data...",
        allowOutsideClick: false,
        didOpen: () =>
          Swal.showLoading(),
      });


      const reportPayload = {

        fromDate,

        toDate,

        status,

      };


      const response =
        await RequestServies
          .downloadRequisitionReport(
            reportPayload
          );


      const blob =
        new Blob(
          [response.data]
        );


      const url =
        window.URL
          .createObjectURL(
            blob
          );


      const link =
        document
          .createElement(
            "a"
          );


      link.href =
        url;


      const currentDate =
        new Date()
          .toISOString()
          .split("T")[0];


      const fileName =
        `Requisition_Report_${currentDate}.xlsx`;


      link.setAttribute(
        "download",
        fileName
      );


      document.body
        .appendChild(
          link
        );


      link.click();

      link.remove();


      window.URL
        .revokeObjectURL(
          url
        );


      Swal.fire({
        icon: "success",
        title: "Download Successful",
        text: "Report Downloaded Successfully.",
      });


    } catch (error) {

      console.error(
        "Download Error:",
        error
      );


      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error?.response
            ?.data
            ?.message ||
          "Unable to download report.",
      });

    }

  };


  return (

    <>

      <div className="col-xl-12">

        {/* ======================================
            FILTER
        ====================================== */}

        <div className="filter cm-content-box box-primary">

          <div className="content-title">

            <div className="cpa">

              <i className="fas fa-filter me-2"></i>

              Filter

            </div>


            <div className="tools">

              <Link

                to="#"

                className={`SlideToolHeader ${
                  open
                    ? "collapse"
                    : "expand"
                }`}

                onClick={() =>
                  setOpen(
                    !open
                  )
                }

              >

                <i className="fas fa-angle-up"></i>

              </Link>

            </div>

          </div>


          <Collapse in={open}>

            <div className="cm-content-body form excerpt">

              <div className="card-body">

                <div className="row">


                  {/* FROM */}

                  <div className="col-xl-3 col-xxl-3">

                    <label className="ms-2">

                      From

                    </label>


                    <input

                      type="date"

                      name="fromDate"

                      className="form-control mb-xxl-0 mb-3"

                      value={fromDate}

                      onChange={(e) =>
                        setFromDate(
                          e.target.value
                        )
                      }

                    />

                  </div>


                  {/* TO */}

                  <div className="col-xl-3 col-xxl-3">

                    <label className="ms-2">

                      To

                    </label>


                    <input

                      type="date"

                      name="toDate"

                      className="form-control mb-xxl-0 mb-3"

                      value={toDate}

                      onChange={(e) =>
                        setToDate(
                          e.target.value
                        )
                      }

                    />

                  </div>


                  {/* STATUS */}

                  <div className="col-xl-3 col-xxl-3">

                    <label className="ms-2">

                      Status

                    </label>


                    <select

                      className="form-select"

                      value={status}

                      style={{
                        height: "55px"
                      }}

                      onChange={(e) =>
                        setStatus(
                          e.target.value
                        )
                      }

                    >

                      <option value="all">
                        All
                      </option>

                      <option value="recived">
                        Completed
                      </option>

                      <option value="pending">
                        Admin Approval Pending
                      </option>

                      <option value="rejected">
                        Rejected
                      </option>

                      <option value="approvedByAdmin">
                        SuperAdmin Approval Pending
                      </option>

                      <option value="approved">
                        Receive Order Pending
                      </option>

                    </select>

                  </div>


                  {/* ACTION */}

                  <div className="col-xl-3 col-xxl-3">

                    <label className="ms-2">

                      Action

                    </label>


                    <div className="d-flex gap-2">

                      <button

                        className="form-control btn btn-primary"

                        onClick={
                          fetchReport
                        }

                        disabled={
                          loading
                        }

                      >

                        {
                          loading
                            ? "Loading..."
                            : "Generate"
                        }

                      </button>


                      <button

                        className="btn btn-success w-100"

                        onClick={
                          downloadExcel
                        }

                        disabled={
                          !fromDate ||
                          !toDate
                        }

                      >

                        Download

                      </button>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </Collapse>

        </div>


        {/* ======================================
            REPORT TABLE
        ====================================== */}

        <div className="filter cm-content-box box-primary">

          <div className="content-title">

            <div className="cpa">

              <i
                className="fa fa-list me-2"
                aria-hidden="true"
              ></i>

              Requisition Report

              <span className="badge bg-orange ms-2">

                {totalcount}

              </span>

            </div>


            <div className="tools">

              <Link

                to="#"

                className={`SlideToolHeader ${
                  open2
                    ? "collapse"
                    : "expand"
                }`}

                onClick={() =>
                  setOpen2(
                    !open2
                  )
                }

              >

                <i className="fas fa-angle-up"></i>

              </Link>

            </div>

          </div>


          <Collapse in={open2}>

            <div className="cm-content-body form excerpt">

              <div className="card-body">


                {!loading &&
                  reportData?.length > 0 && (

                    <div className="row mb-2">

                      <div className="col-12">

                        <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">

                          <input

                            className="form-control"

                            style={{
                              width:
                                "500px"
                            }}

                            id="searchInput"

                            placeholder="Search by Store, Request No, PO No, Part No or Description"

                            value={
                              searchQuery
                            }

                            onChange={(e) =>
                              setSearchQuery(
                                e.target.value
                              )
                            }

                          />

                        </div>

                      </div>

                    </div>

                  )}


                <div className="scrolltable">

                  <table className="table table-bordered table-striped">

                    <thead className="sticky-table-header">

                      <tr>

                        <th>S.No</th>
                        <th>Store</th>
                        <th>Requisition No</th>
                        <th>Date</th>
                        <th>Po No.</th>
                        <th>Po Date</th>
                        <th>Bill No</th>
                        <th>Total Amount</th>
                        <th>Other Charges</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th>Auth</th>
                        <th>C-Stock</th>
                        <th>Required Qty</th>
                        <th>Approved Qty</th>
                        <th>Received Qty</th>
                        <th>Supplier</th>
                        <th>Status</th>
                        <th>MRV No</th>
                        <th>Item Receievd Date</th>
                        <th>Reason</th>
                        <th>Final Status</th>
                        <th>Requisition img</th>
                        <th>Bill Image</th>

                      </tr>

                    </thead>


                    <tbody>

                      {
                        filteredData.length > 0
                          ? (
                            <>

                              {
                                filteredData.map(
                                  (
                                    item,
                                    index
                                  ) => (

                                    <tr key={index}>

                                      <td>
                                        {index + 1}
                                      </td>

                                      <td className="scrollable-description">
                                        {
                                          item
                                            ?.inventory
                                            ?.store
                                            ?.name
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.requisitionNo
                                            ?.requisitionNo
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.requisitionNo
                                            ?.createdAt
                                            ?.split(
                                              "T"
                                            )[0]
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.po
                                            ?.poNumber ||
                                          "Local"
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.po
                                            ?.createdAt
                                            ?.split(
                                              "T"
                                            )[0]
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.mrv
                                            ?.billingNo ||
                                          "NA"
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.mrv
                                            ?.totalAmount ||
                                          "NA"
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.mrv
                                            ?.otherCharges ||
                                          "NA"
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.inventory
                                            ?.masterItem
                                            ?.partNo
                                        }
                                      </td>

                                      <td className="scrollable-description">
                                        {
                                          item
                                            ?.inventory
                                            ?.masterItem
                                            ?.description
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.inventory
                                            ?.masterItem
                                            ?.unit
                                            ?.name
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.inventory
                                            ?.qtyAuth
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.inventory
                                            ?.currentStock
                                            ?.toFixed(
                                              2
                                            )
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.qtyRequired
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.approveQty
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.qtyRecived
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.mrv
                                            ?.supplier
                                            ?.name
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.status
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.mrv
                                            ?.mrvNo
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.updatedAt
                                            ?.split(
                                              "T"
                                            )[0]
                                        }
                                      </td>

                                      <td>
                                        {
                                          item
                                            ?.adminRemark
                                        }
                                      </td>


                                      <td>

                                        {
                                          item?.status ===
                                          "approved"
                                            ? "Pending for Receive"

                                            : item?.status ===
                                              "approvedByAdmin"
                                            ? "SuperAdmin Approval Pending"

                                            : item?.status ===
                                              "recived"
                                            ? "Completed"

                                            : item?.status ===
                                              "pending"
                                            ? "Admin Approval Pending"

                                            : item?.status ===
                                              "rejected"
                                            ? "Rejected"

                                            : item?.status ===
                                              "autoclosed"
                                            ? "Autoclosed"

                                            : item?.status ===
                                              "forceclosed"
                                            ? "Forceclosed"

                                            : item?.status ===
                                              "tranfer request"
                                            ? "Transfer Request"

                                            : item?.status ===
                                              "local"
                                            ? "Transfer Local Purchase"

                                            : "Unknown Status"
                                        }

                                      </td>


                                      <td className="scrollable-description">

                                        {
                                          item
                                            ?.requisitionNo
                                            ?.image
                                            ? (

                                              <span

                                                style={{
                                                  color:
                                                    "blue",
                                                  textDecoration:
                                                    "underline",
                                                  cursor:
                                                    "pointer"
                                                }}

                                                onClick={() =>
                                                  window.open(
                                                    `https://indigoinfra.in/img/requisitionform/${item?.requisitionNo?.image}`,
                                                    "_blank"
                                                  )
                                                }

                                              >

                                                View Image-
                                                {
                                                  item
                                                    ?.requisitionNo
                                                    ?.requisitionNo
                                                }

                                              </span>

                                            )
                                            : "No image available"
                                        }

                                      </td>


                                      <td>

                                        {
                                          item
                                            ?.mrv
                                            ?.image
                                            ? (

                                              <span

                                                style={{
                                                  color:
                                                    "blue",
                                                  textDecoration:
                                                    "underline",
                                                  cursor:
                                                    "pointer"
                                                }}

                                                onClick={() =>
                                                  window.open(
                                                    `https://indigoinfra.in/img/mrv/${item?.mrv?.image}`,
                                                    "_blank"
                                                  )
                                                }

                                              >

                                                View Image-
                                                {
                                                  item
                                                    ?.mrv
                                                    ?.mrvNo
                                                }

                                              </span>

                                            )
                                            : "No image available"
                                        }

                                      </td>

                                    </tr>

                                  )
                                )
                              }


                              <tr>

                                <td
                                  colSpan="16"
                                  className="text-end"
                                >

                                  <strong>

                                    Total Received Qty:

                                  </strong>

                                </td>


                                <td colSpan="10">

                                  <strong>

                                    {
                                      totalReceivedQty
                                    }

                                  </strong>

                                </td>

                              </tr>

                            </>
                          )
                          : (

                            <tr>

                              <td
                                colSpan="25"
                                className="text-center"
                              >

                                No data available.

                              </td>

                            </tr>

                          )
                      }

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

          </Collapse>

        </div>

      </div>

    </>

  );

};

export default RequisitionReport;